<template>
  <div class="exam-paper survey-detail">
    <div class="header">
      <div v-if="query" class="header-text">
        <div class="header-title">{{query.title}}</div>
        <div class="header-user">
          <img :src="userInfo.photo | imgFilter" alt="">
          参考人：{{query.username}}
        </div>
      </div>
    </div>

    <div class="content">
      <div class="content-left">
        <!-- 题型 -->
        <div v-for="(item, index) in subjectList" :key="index" v-if="subjectList && subjectList.length > 0">
          <!-- 单选 -->
          <div v-if="item.type === 0" class="exam-item exam-singel">
            <div class="title" :class="item.isRequired ? 'title-imp' : ''">{{index + 1}}、【单选】{{item.title}}</div>
            <el-radio-group class="select" v-model="item.answer">
              <el-radio class="option" v-for="(items, indexs) in item.quesSubjectItemResultList" :key="indexs" :label="indexs">{{letterList[indexs]}}、{{items.content}}</el-radio>
            </el-radio-group>
          </div>

          <!-- 多选 -->
          <div v-if="item.type === 1" class="exam-item exam-double">
            <div class="title" :class="item.isRequired ? 'title-imp' : ''">{{index + 1}}、【多选】{{item.title}}</div>
            <el-checkbox-group class="select" v-model="item.answer">
              <el-checkbox class="option" v-for="(items, indexs) in item.quesSubjectItemResultList" :key="indexs" :label="indexs">{{letterList[indexs]}}、{{items.content}}</el-checkbox>
            </el-checkbox-group>
          </div>

          <!-- 问答 -->
          <div v-if="item.type === 2" class="exam-item exam-qa">
            <div class="title" :class="item.isRequired ? 'title-imp' : ''">{{index + 1}}、【问答】{{item.title}}</div>
            <el-input type="textarea" v-model="item.answer" maxlength="400" placeholder="请输入答案" class="input"></el-input>
          </div>
        </div>

        <div class="survey-btns">
          <div class="survey-btn" @click="handleSubmit">提交</div>
          <div class="survey-btn survey-btn-back" @click="handleBack">返回</div>
        </div>
      </div>
    </div>

    <Footerbar></Footerbar>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Footerbar from '../layout/components/Footerbar.vue'
import {getStorgeItem, setStorgeItem} from '@/utils/auth'
export default {
  name: 'SurveyDetail',
  components: {
    Footerbar
  },
  data() {
    return {
      query: null,
      detail: null,
      subjectList: [], // 考题
      letterList: ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z'], // 字母表
    }
  },
  computed: {
    ...mapGetters([
  		'userInfo'
    ])
  },
  mounted() {
    if(this.$route.query.page === 'course' || this.$route.query.page === 'station' || this.$route.query.page === 'classroom'){
      this.handleSurveySubDetail()
    }else{
      this.handleSurveyDetail()
    }
  },
  methods: {
    // 获取问卷调研详情
    handleSurveySubDetail() {
      let params = {
        id: this.$route.query.id,
        courseId: this.$route.query.cid || '',
        topicId: this.$route.query.topicId || '',
        trainId: this.$route.query.trainId || ''
      }
      this.$api.course.surveySubDetail(params).then(res => {
        this.query = {
          title: res.data.title,
          username: this.userInfo.realname
        }
        this.detail = res.data
        for(let item of res.data.quesSubjectResults){
          if(item.type === 0){
            //单选
            this.$set(item, 'answer','')
          }
          if(item.type === 1){
            //多选
            this.$set(item, 'answer', [])
          }
          if(item.type === 2){
            //问答
            this.$set(item, 'answer', '')
          }
          this.$set(item, 'title', this.$util.removeHtml(item.title))
        }
        this.subjectList = res.data.quesSubjectResults
      })
    },
    // 获取调研详情
    handleSurveyDetail() {
      this.$api.course.surveyDetail({id: this.$route.query.id}).then(res => {
        this.query = {
          title: res.data.title,
          username: this.userInfo.realname
        }
        this.detail = res.data
        for(let item of res.data.quesSubjectDataResultList){
          if(item.type === 0){
            //单选
            this.$set(item, 'answer','')
          }
          if(item.type === 1){
            //多选
            this.$set(item, 'answer', [])
          }
          if(item.type === 2){
            //问答
            this.$set(item, 'answer', '')
          }
          this.$set(item, 'title', this.$util.removeHtml(item.title))
        }
        this.subjectList = res.data.quesSubjectDataResultList
      })
    },
    handleSubmit() {
      let params = {
        id: this.$route.query.id,
        courseId: this.$route.query.cid || '',
        quesId: this.detail.quesId || '',
        quesSubjectResultIOList: [],
        topicId: this.$route.query.topicId || '',
        trainId: this.$route.query.trainId || '',
      }
      for(let i in this.subjectList){
        let item  = this.subjectList[i]
        // 必填判断
        if(item.isRequired){
          if((item.answer + 1).length === 1){
            return this.$message({message: '有必答题未填写，请回答后再提交', type: 'warning'})
          }
          // 多选题最多选几项和最少选几项的判断
          if(item.type === 1){
            let len = item.answer.length
            if(len < item.min){
              return this.$message({message: '第' + (i * 1 + 1) + '题最少选' + item.min + '项', type: 'warning'})
            }
            if(len > item.max){
              return this.$message({message: '第' + (i * 1 + 1) + '题最多选' + item.max + '项', type: 'warning'})
            }
          }
        }else{
          // 非必填多选题，最多选几项和最少选几项的判断
          if(item.type === 1){
            let len = item.answer.length
            if(len > 0){
              if(len < item.min){
                return this.$message({message: '第' + (i * 1 + 1) + '题最少选' + item.min + '项', type: 'warning'})
              }
              if(len > item.max){
                return this.$message({message: '第' + (i * 1 + 1) + '题最多选' + item.max + '项', type: 'warning'})
              }
            }
          }
        }

        // 单选
        if(item.type === 0){
          for(let i = 0; i < item.quesSubjectItemResultList.length; i++){
            item.quesSubjectItemResultList[i].isSelect = 0
            if(i === item.answer * 1){
              item.quesSubjectItemResultList[i].isSelect = 1
            }
          }
          params.quesSubjectResultIOList.push({id: item.id, isRequired: item.isRequired, type: item.type, quesSubjectItemResultIOList: item.quesSubjectItemResultList})
        }
        // 多选
        if(item.type === 1){
          for(let i = 0; i < item.quesSubjectItemResultList.length; i++){
            item.quesSubjectItemResultList[i].isSelect = 0
            for(let items of item.answer){
              if(items * 1 === i){
                item.quesSubjectItemResultList[i].isSelect = 1
              }
            }
          }
          params.quesSubjectResultIOList.push({id: item.id, isRequired: item.isRequired, type: item.type, quesSubjectItemResultIOList: item.quesSubjectItemResultList})
        }
        // 问答
        if(item.type === 2){
          let quesSubjectItemResultIOList = [{content: item.answer}]
          params.quesSubjectResultIOList.push({id: item.id, isRequired: item.isRequired, type: item.type, quesSubjectItemResultIOList: quesSubjectItemResultIOList})
        }
      }
      if(this.$route.query.page === 'course' || this.$route.query.page === 'station' || this.$route.query.page === 'classroom'){
        params.quesId = this.$route.query.id
        this.$api.course.surveySubSubmitQues(params).then(res => {
          this.$message({message: '提交成功', type: 'success'})
          this.$router.back()
        })
      }else{
        this.$api.course.surveySubmitQues(params).then(res => {
          this.$message({message: '提交成功', type: 'success'})
          this.$router.back()
        })
      }
    },
    handleBack() {
      this.$router.back()
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../styles/examPaper.scss';
</style>

